const auditLogTypesAllReducer = (state = [{code: "all", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDSHARK_AUDIT_LOG_TYPES_ALL':
      return action.results;
    default:
      break;
  }
  return state;
}

export default auditLogTypesAllReducer;